<template>
  <BlockTemplate class="block" theme="neutral" expandable="closed">
    <template #header>
      <BlockHeader
        ref="header"
        class="header"
        :likable="false"
        :checkable="false"
        :like="false"
        :check="false"
      >
        <slot name="title" />
      </BlockHeader>
    </template>
    <div class="content">
      <div class="items">
        <slot />
      </div>
      <ButtonBase
        v-if="action"
        theme="secondary"
        stroke="n"
        class="button"
        :disabled="false"
        rounded
        size="small"
        @click="emit('action')"
      >
        <slot name="action" />
      </ButtonBase>
    </div>
  </BlockTemplate>
</template>
<script setup lang="ts">
interface Props {
  action: boolean;
}
defineProps({
  action: { type: Boolean }
});
const emit = defineEmits(["action"]);
</script>
<style lang="scss" scoped>
.block {
  transition: border 100ms $ease-out-quad, box-shadow 300ms $ease-in-quad;
  border: var(--stroke_thickness_l) solid var(--color_neutral_50);
  background-color: var(--color_neutral_25);
  box-shadow: rgb(0 0 0 / 6%) 0 1px 3px 0, rgb(0 0 0 / 3%) 0 1px 2px 0,
    rgb(0 0 0 / 6%) 0 -1px 2px 0;
  @include pointer-desktop {
    &:focus,
    &:hover {
      transition: border 200ms $ease-in-quad, box-shadow 200ms $ease-out-quad;
      border: var(--stroke_thickness_l) solid var(--color_neutral_600);
    }
    &.expanded {
      border: var(--stroke_thickness_l) solid var(--color_neutral_50);
    }
  }
}
section {
  display: flex;
  flex-direction: column;
  gap: var(--gap_m);
}
.content {
  display: flex;
  flex-direction: column;
  gap: var(--gap_l);
  align-items: center;
}
.items {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--gap_m);
  @include above('l') {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--gap_l);
  }
}
.title {
  h3 {
    @include font('l', 600, 'secondary');
  }
}
</style>
